import React from 'react'
import { Flex, Img } from '@chakra-ui/react'
import LogoIB from '../../assets/images/Logotipo.svg'
import ReferralsLogo from '../../assets/images/ReferidosLogo.svg'

const HeaderOffRoad = () => (
  <Flex
    data-testid='headerOffRoad'
    background='linear-gradient(90deg, #522a58 0%, #221f20 90%)'
    height='96px'
    justifyContent='space-between'
  >
    <Img src={ReferralsLogo} alt='' width='257.79px' ml='64px' />
    <Img src={LogoIB} alt='' width='88.66px' mr='64px'/>
  </Flex>
)

export default HeaderOffRoad
